import React from 'react';
import { Package } from 'lucide-react';
import { ScrollFadeIn } from './ScrollFadeIn';
export function ValueTable() {
  return <section className="py-10 bg-slate-800/30 border-y border-slate-800" data-id="element-508">
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-509">
        <ScrollFadeIn data-id="element-510">
          <div className="text-center mb-12" data-id="element-511">
            <Package className="w-10 h-10 text-amber-500 mx-auto mb-4" data-id="element-512" />
            <h2 className="text-3xl md:text-4xl font-serif text-slate-50" data-id="element-513">
              Everything You're Getting Today
            </h2>
          </div>
        </ScrollFadeIn>

        <ScrollFadeIn delay={0.1} data-id="element-514">
          <div className="bg-slate-800 border border-slate-700 rounded-2xl overflow-hidden shadow-2xl" data-id="element-515">
            {/* Row 1 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-516">
              <span className="text-slate-50 font-medium" data-id="element-517">
                The Cortisol Switch (Main eBook)
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-518">
                $37
              </span>
            </div>

            {/* Row 2 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-519">
              <span className="text-slate-50 font-medium" data-id="element-520">
                Bonus #1: The 3AM Rescue Kit
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-521">
                $37
              </span>
            </div>

            {/* Row 3 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700" data-id="element-522">
              <span className="text-slate-50 font-medium" data-id="element-523">
                Bonus #2: Cortisol-Safe Grocery Map
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-524">
                $37
              </span>
            </div>

            {/* Row 4 */}
            <div className="flex items-center justify-between px-6 py-5 border-b border-slate-700 bg-slate-800/50" data-id="element-525">
              <span className="text-slate-50 font-medium" data-id="element-526">
                Bonus #3: The Coffee Exit Plan
              </span>
              <span className="text-slate-400 font-medium shrink-0 ml-4" data-id="element-527">
                $37
              </span>
            </div>

            {/* Total Value */}
            <div className="flex items-center justify-between px-6 py-5 border-b-2 border-amber-500/30 bg-amber-500/5" data-id="element-528">
              <span className="text-amber-400 font-bold uppercase tracking-wide text-sm" data-id="element-529">
                Total Value
              </span>
              <span className="text-amber-400 font-bold text-xl shrink-0 ml-4" data-id="element-530">
                $148
              </span>
            </div>

            {/* Your Price */}
            <div className="flex items-center justify-between px-6 py-8 bg-slate-900" data-id="element-531">
              <span className="text-slate-50 font-bold text-lg" data-id="element-532">
                Your Price Today
              </span>
              <span className="text-emerald-400 font-bold text-4xl shrink-0 ml-4" data-id="element-533">
                $6.39
              </span>
            </div>
          </div>
        </ScrollFadeIn>
      </div>
    </section>;
}